<template>
    <div>
        <Title title="订阅记录" path="/my"/>

        <div class="userwrap">
            <div class="accbox">
                <div class="page-loading" v-if="isInit === true">
                    <van-skeleton title :row="8" />
                </div>
                <template v-else>

                    <div class="tuijiebox tuijiebox_sc" v-if="list.length>0">

                        <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">
                            <van-list v-model="isLoading"
                                      finished-text="没有了~"
                                      :immediate-check="false"
                                      :finished="isFinished"
                                      :error.sync="isError"
                                      :error-text="list.length>0?'读取失败':''"
                                      @load="onLoadMore">
                            <van-checkbox-group v-model="ids">

                            <div v-for="(c, i) in list" :key="i" class="item">

                                <div class="hdtme" v-if="c.hasParent">
                                    <div class="tm">时间：{{ c.create_time }}</div>
                                    <div class="coin">
                                            <span v-if="c.parent_amt_coupon">优惠券<b>-{{ c.parent_amt_coupon }}</b>，</span>
                                            <span v-if="c.parent_amt_integral">积分<b>-{{ c.parent_amt_integral }}</b>，</span>
                                            <span>实付<em>{{ c.parent_amt_total }}</em></span>
<!--                                        <i>FXB</i>-->
                                        </div>
<!--                                        <div class="del" @click="delscr(i)"></div>-->
                                </div>

                                <van-swipe-cell>
                                    <van-cell>
                                    <div class="hd">
                                        <div class="vanchk" v-if="c.match.result_id !== 1">
                                            <van-checkbox :name="c.cid" shape="square" checked-color="#f4882a" icon-size="14px" />
                                        </div>
<!--                                        <input type="checkbox" v-model="ids" :value="c.cid"/>-->
                                        <div class="ss" :style="{color:c.match.color}">{{ c.match.match_type }}</div>
                                        <div class="time">{{ c.match.match_time }}</div>
                                        <span v-if="c.isretreat" class="fan">已返还</span>
                                        <div class="ex">
                                            <template v-if="c.match.isfree">单场精选</template>
                                            <router-link :to="'/expert/'+c.match.expert_eid" v-else>
                                                <img :src="c.match.expert_portrait" class="port"/>
                                                <span class="t">{{ c.match.expert_name }}</span>
                                            </router-link>
                                        </div>
                                    </div>
                                        <div class="con">
                                    <div class="dz">
                                        <router-link :to="'/match/'+c.match.mid">{{ c.match.shangpan }}
                                            <span class="bf" v-if="c.match.bifen !== '-'">{{c.match.bifen}}</span>
                                            <span class="bf" v-else>VS</span>{{ c.match.xiapan }}
                                        </router-link>
                                        <div class="pk">
                                            <em v-if="c.match.dxq">大小球</em><em v-else>让球</em>{{ c.match.pankou }}
                                        </div>
                                    </div>
                                    <div class="res">
<!--                                            <template v-if="c.match.amt !== c.amt_total">-->
<!--                                                <span class="od"><i>原售</i>{{ c.match.amt }}<em>FXB</em></span>-->
<!--                                                <span class="sj"><i>订阅价</i>{{ c.amt_total }}<em>FXB</em></span>-->
<!--                                            </template>-->
                                        <span class="ds"><i>订阅价</i>{{ c.amt_total }}<em>FXB</em></span>
                                        <div class="bm">
                                            <div class="tj">
                                                <router-link :to="'/match/'+c.match.mid" class="det"><span>荐</span>{{ c.match.commend }}</router-link>
                                            </div>
                                            <div class="jg"><span :class="'j'+c.match.result_id">{{ c.match.result }}</span></div>
                                        </div>
                                    </div>
                                </div>
                                    </van-cell>
                                    <template #right v-if="c.match.result_id!==1">
                                        <van-button square type="danger" @click="delscr(i)" text="删除" />
                                    </template>
                                </van-swipe-cell>


                            </div>
                            </van-checkbox-group>
                            </van-list>
                        </van-pull-refresh>

                        <div class="fxboex accbtm">
                            <div class="conx">
                            <van-checkbox v-model="ischkAll" shape="square" checked-color="#f4882a" icon-size="18px">全选</van-checkbox>
                            <button @click="delscribe">删除</button>
                                <span class="seleng" v-if="ids.length">已选择<b>{{ids.length}}</b>场</span>
                            </div>
                        </div>
                    </div>

                    <van-empty description="没有记录~" v-else/>
                </template>


            </div>
        </div>

    </div>
</template>

<script>
    import '../../assets/css/user.css'
    import Title from '../public/title'
    export default {
        name: "subscribe",
        components: {
            Title
        },
        data (){
            return {
                list: [],
                page: 1,
                isInit: true,
                isRefresh: false,
                isLoading: false,
                isLoadingError: false,
                isFinished: false,
                isError: false,

                ids: [],
                ischkAll: false
            }
        },
        watch: {
            '$route'(v) {
                // console.log(this.$route.path)
                if(v.name === 'mysubscribe') {
                    this.page = 1
                    this.isInit = true
                    this.ids = []
                    this.ischkAll = false
                    this.getdata()
                }
            },
            ischkAll(v){
                let that = this
                that.ids = []
                if(v){
                    that.ids = []
                    that.list.forEach(function (c) {
                        if(c.match.result_id !== 1)
                            that.ids.push(c.cid)
                    })
                    // console.log(that.ids)
                }
                // console.log(that.ids)
            },
            // ids(v){
            //     console.log(v)
            // },
            list(v){
                // console.log(v.length)
                let that = this
                let tmplist = []
                v.forEach(function(c){
                    // console.log(c)
                    tmplist.push(c.cid)
                })
                // console.log(tmplist)
                // console.log(that.ids)
                that.ids.forEach(function (k, i) {
                    if(tmplist.indexOf(k) === -1){
                        that.ids.splice(i, 1)
                    }
                })
            }
        },
        created() {
            let that = this
            that.getdata()
        },
        methods: {
            onRefresh(){
                let that = this
                this.page = 1
                this.isLoading = false
                this.isFinished = false
                this.isError = false
                setTimeout(function () {
                    that.getdata()
                }, 200)
            },
            onLoadMore(){
                let that = this
                if(!that.isLoadingError)
                    that.page++
                that.getdata()
            },
            getdata(){
                let that = this
                this.$get(that.$api.member_subscribe, {page: that.page}).then(function (res) {
                    if (res.code === 1){
                        if(that.page === 1){
                            that.list = []
                            that.$backTop()
                        }
                        // that.total = res.data.total
                        // that.size = res.data.size
                        let tmplist = res.data.list
                        if(tmplist.length > 0) {
                            if (that.isRefresh) {
                                that.list = tmplist
                            } else {
                                that.list = that.list.concat(tmplist)
                            }
                        }
                        else{
                            that.isFinished = true
                        }
                        that.isInit = false
                    }
                    else{
                        that.isError = true
                    }
                })
                .catch(function () {
                    that.isError = true
                    that.isLoadingError = true
                })
                .finally(function () {
                    that.isRefresh = false
                    that.isLoading = false
                })
            },
            delscr(i){
                let that = this
                that.$dialog.confirm({
                    title: '确认',
                    message: '确定删除该条记录？',
                }).then( () => {
                    let cid = that.list[i].cid
                    that.$toast.loading({message: '请稍后', forbidClick: true, duration: 0})
                    that.$post(that.$api.member_scribe_delete, {cid: cid})
                        .then(function (res) {
                            if(res.code === 1){
                                that.list.splice(i,1)
                                that.$toast.success(res.msg)
                            }
                            else{
                                that.$toast.fail(res.msg)
                            }
                        })
                })
            },

            delscribe(){
                // console.log(this.ids)
                let that = this
                // console.log(that.ids)
                if(this.ids.length===0){
                    this.$toast('请选择一项')
                    return
                }
                that.$dialog.confirm({
                    title: '确认',
                    message: '确定删除选择项吗？',
                }).then( () => {
                    that.$post(that.$api.member_scribe_action, {ids: that.ids.join(',')}).then(function (res) {
                        // console.log(res)
                        if(res.code === 1){
                            that.$toast.success(res.msg)

                            //页面删除选中项
                            let del_item_list = []
                            that.list.forEach(function (c, i) {
                                if(that.ids.indexOf(c.cid) > -1)
                                    del_item_list.push(i)
                            })
                            del_item_list.reverse().forEach(function (c) {
                                that.list.splice(c, 1)
                            })
                            that.ids = []
                        }
                    })
                }).catch(()=>{})
            },
        },
    }
</script>

<style scoped>
</style>
